export type Currency = "DZD" | "USD" | "EUR";

function groupInteger(amount: number, separator: string): string {
  return String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

/** Format an amount in its currency. DZD/EUR use grouped integers; USD keeps the $ sign. */
export function formatMoney(amount: number, currency: Currency = "DZD"): string {
  if (currency === "USD") {
    return `$${groupInteger(amount, ",")}`;
  }
  return `${groupInteger(amount, " ")} ${currency}`;
}

export function formatDZD(amount: number): string {
  return formatMoney(amount, "DZD");
}

export function formatUSD(amount: number): string {
  return formatMoney(amount, "USD");
}

export function formatPercent(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`;
}

export function formatDelta(value: number): { label: string; direction: "up" | "down" | "neutral" } {
  if (value > 0) return { label: `+${value.toFixed(1)}%`, direction: "up" };
  if (value < 0) return { label: `${value.toFixed(1)}%`, direction: "down" };
  return { label: "0%", direction: "neutral" };
}

/** Convert USD to DZD using a manual rate (mirrors the mockup's 218.5 DZD/$). */
export function usdToDzd(usd: number, rate = 218.5): number {
  return usd * rate;
}

export function initialsOf(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .map((part) => part[0] ?? "")
    .join("")
    .toUpperCase()
    .slice(0, 2);
}
